<template>
	<div class="container">
		<div class="content" v-html="policyContent"></div>
			
		</div>
	</div>
</template>

<script>
	import { protocol } from '@/api/user/user';
	export default {
		components: {
			// ScrollView,
		},
		data() {
			return {
				policyContent: '',
				what:'',//什么协议
			}
		},
		created() {
			this.getPolicy()
			this.what = this.$route.query.what;
		},
		methods: {
			async getPolicy() {
				// const data = await protocol()
				// console.log(data);
				protocol().then(res => {
					console.log(res);
					this.policyContent = this.what == 'xieyi' ? res.rows[0].userAgreementContent : res.rows[0].privacyPolicyContent
				})
			},
		},
	};
</script>

<style lang="scss" scoped>
	.container{
		width: 1200px;
		margin: 40px auto 90px;
		background-color: #fff;
		border-radius: 8px 8px 8px 8px;
		min-height: 970px;
		padding: 40px 68px;
		box-sizing: border-box;
	}
</style>